import { Blueprint } from 'types';

type BlueprintCalculation = Blueprint['calculations'][number];

export const calculateSavingsPercentage = (
  baseValue: number | null | undefined,
  hybridValue: number | null | undefined
) => {
  if (
    baseValue === null ||
    baseValue === undefined ||
    hybridValue === null ||
    hybridValue === undefined ||
    baseValue === 0
  ) {
    return '';
  }
  const savings = baseValue - hybridValue;
  const percentage = ((savings / baseValue) * 100).toFixed(0);
  const percentageValue = parseFloat(percentage);

  if (percentageValue === 0) {
    return '0%';
  }

  const sign = percentageValue > 0 ? '-' : '+';
  const absolutePercentage = Math.abs(percentageValue);
  return `${sign}${absolutePercentage}%`;
};

export const calculateSavingsAmount = ({
  baseValue,
  hybridValue,
  formatter = (val) => val.toString(),
}: {
  baseValue: number | null | undefined;
  hybridValue: number | null | undefined;
  formatter?: (value: number) => string;
}) => {
  if (
    baseValue === null ||
    baseValue === undefined ||
    hybridValue === null ||
    hybridValue === undefined ||
    (baseValue === 0 && hybridValue === 0)
  ) {
    return '';
  }
  const savings = baseValue - hybridValue;
  const sign = savings > 0 ? '-' : savings < 0 ? '+' : '';
  const absoluteSavings = Math.abs(savings);
  return `${sign}${formatter(absoluteSavings)}`;
};

export const isPositiveSavings = (savings?: string) => {
  if (!savings || savings === '-' || savings === '0%') {
    return false;
  }
  return savings.startsWith('-');
};

export const mapCalculationToTableData = (
  calculation: BlueprintCalculation,
  overrides?: { batteryRentalCostCents?: number }
) => {
  return {
    currencyCode: calculation.currencyCode,
    calculationResult: calculation.calculationResult,
    costAssumptions: {
      ...calculation.costAssumptions,
      batteryRentalCostCents: overrides?.batteryRentalCostCents ?? calculation.costAssumptions.batteryRentalCostCents,
    },
  };
};
